import React, { useState, useEffect } from "react";
import hiveLeft from "images/landing-page/hive-left.png";
import hiveRight from "images/landing-page/hive-right.png";
import BusinessModal from "./components/BusinessForm";
import SuccessModal from "./components/SuccessModal";
import YoutubeVideoPlayer from "../../components/assets/YoutubeVideoPlayer";

const MainHeader = () => {
  const [isFormModalVisible, setIsFormModalVisible] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  return (
    <>
      <div className="header-background"></div>

      <img
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          minWidth: 347,
          width: "20%",
          zIndex: -1,
        }}
        src={hiveLeft}
      />

      <img
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          minWidth: 347,
          width: "20%",
          zIndex: -1,
        }}
        src={hiveRight}
      />

      <div className="margin-100-zero" style={{ textAlign: "center" }}>
        <div className="header-title" style={{ marginBottom: 30 }}>
          {"Siuntų siuntimas verslui - patogiai ir lengvai!"}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 29,
          }}
        >
          <p className="text-font" style={{ maxWidth: 880 }}>
            {
              "Tikime, jog mūsų sukurta siuntų siuntimo ir valdymo platforma padės Jūsų verslui ne tik sutaupyti, bet ir efektyviai pasiekti pirkėjus visame pasaulyje. Gaukite individualų, Jūsų poreikius atitinkantį bendradarbiavimo pasiūlymą ir siųskite siuntas patogiai ir greitai į bet kurią pasaulio šalį. "
            }
          </p>
        </div>
        <div
          style={{
            maxWidth: 400,
            margin: "auto auto 30px auto",
          }}
        >
          <YoutubeVideoPlayer borderRadius={20} />
        </div>
        <button
          className="get-the-deal"
          onClick={() => {
            setIsFormModalVisible(true);
          }}
        >
          {"Gauti pasiūlymą"}
        </button>
      </div>
      {isFormModalVisible && (
        <BusinessModal
          setIsFormModalVisible={setIsFormModalVisible}
          setIsSuccessModalVisible={setIsSuccessModalVisible}
        />
      )}
      {isSuccessModalVisible && (
        <SuccessModal setIsSuccessModalVisible={setIsSuccessModalVisible} />
      )}
    </>
  );
};

export default MainHeader;
